/**
 * AdminSearchBar — slim local-filter input used across admin list pages.
 *
 * Keeps the lists themselves untouched on the wire (we filter client-side
 * since the admin grids cap at 500–1000 rows). The component is purely
 * presentational + emits the lower-cased query upward.
 */
import { Search, X } from "lucide-react";

export default function AdminSearchBar({ value, onChange, placeholder = "Search…", count, testid = "admin-search" }) {
    return (
        <div className="flex items-center gap-2 bg-card border border-border rounded-xl px-3 py-2 max-w-md">
            <Search size={14} className="text-muted-foreground" />
            <input
                data-testid={testid}
                className="flex-1 bg-transparent text-sm outline-none"
                value={value}
                placeholder={placeholder}
                onChange={(e) => onChange(e.target.value)}
            />
            {value && (
                <button
                    data-testid={`${testid}-clear`}
                    onClick={() => onChange("")}
                    className="p-1 rounded-full hover:bg-muted text-muted-foreground"
                    aria-label="Clear search"
                ><X size={12} /></button>
            )}
            {count != null && (
                <span className="text-[11px] text-muted-foreground font-bold tabular-nums">{count}</span>
            )}
        </div>
    );
}
